module.exports = __webpack_public_path__ + "static/img/JHJQR.88c9c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/JHJQR.png
// module id = w2h/
// module chunks = 34